import { useSyncExternalStore } from 'react';
import { useTranslation } from 'react-i18next';
import { getNeedRefresh, subscribe, applyUpdate } from '../../lib/pwa-register';
import { haptic } from '../../lib/haptic';

/**
 * Persistent green banner that appears when a new service worker is detected.
 * Tap "Refresh" to activate the new SW and reload the page.
 *
 * Mounted as the first child of AppShell, above <AppHeader>. Hidden by
 * default (renders null) until pwa-register fires onNeedRefresh.
 */
export function UpdateBanner() {
  const { t } = useTranslation('common');
  const needRefresh = useSyncExternalStore(subscribe, getNeedRefresh, () => false);
  if (!needRefresh) return null;

  return (
    <div
      role="status"
      style={{
        background: 'var(--color-btn-primary, #1B6A41)',
        color: '#FFFFFF',
        padding: '10px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
      }}
    >
      <span className="text-sm font-medium">
        {t('update_available', { defaultValue: 'New version available' })}
      </span>
      <button
        type="button"
        onClick={async () => {
          haptic.tap();
          await applyUpdate();
        }}
        className="text-sm font-semibold px-3 py-1 rounded-full"
        style={{ background: '#FFFFFF', color: 'var(--color-btn-primary, #1B6A41)' }}
      >
        {t('update_refresh', { defaultValue: 'Refresh' })}
      </button>
    </div>
  );
}
